import React from "react";

const initial = { name: "", model: "", price: "", quantity: "", status: "", is_flagged: "", is_sewing_flagged: "" };

export default function ProductsFilter({ value, onChange }) {
  const [form, setForm] = React.useState(value || initial);
  React.useEffect(() => setForm(value || initial), [value]);

  const setField = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const submit = (e) => {
    e?.preventDefault?.();
    onChange?.(form);
  };
  const reset = () => {
    setForm(initial);
    onChange?.(initial);
  };

  return (
    <form onSubmit={submit}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
          gap: 12,
          alignItems: "flex-end"
        }}
      >
        <div className="oc-field">
          <label>Product Name</label>
          <input
            className="oc-input"
            value={form.name}
            onChange={(e) => setField("name", e.target.value)}
            placeholder="Product Name"
          />
        </div>
        <div className="oc-field">
          <label>Model</label>
          <input
            className="oc-input"
            value={form.model}
            onChange={(e) => setField("model", e.target.value)}
            placeholder="Model"
          />
        </div>
        <div className="oc-field">
          <label>Price</label>
          <input
            className="oc-input"
            value={form.price}
            onChange={(e) => setField("price", e.target.value)}
            placeholder="Price"
          />
        </div>
        <div className="oc-field">
          <label>Quantity</label>
          <input
            className="oc-input"
            value={form.quantity}
            onChange={(e) => setField("quantity", e.target.value)}
            placeholder="Quantity"
          />
        </div>
        <div className="oc-field">
          <label>Status</label>
          <select
            className="oc-select"
            value={form.status}
            onChange={(e) => setField("status", e.target.value)}
          >
            <option value="">All</option>
            <option value="1">Enabled</option>
            <option value="0">Disabled</option>
          </select>
        </div>
        <div className="oc-field">
          <label>Flagged</label>
          <select
            className="oc-select"
            value={form.is_flagged}
            onChange={(e) => setField("is_flagged", e.target.value)}
          >
            <option value="">All</option>
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
        </div>
        <div className="oc-field">
          <label>Sewing</label>
          <select
            className="oc-select"
            value={form.is_sewing_flagged}
            onChange={(e) => setField("is_sewing_flagged", e.target.value)}
          >
            <option value="">All</option>
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
        </div>
        <div
          className="oc-actions"
          style={{ display: "flex", gap: 8, justifyContent: "flex-start" }}
        >
          <button className="oc-btn" type="submit">
            Filter
          </button>
          <button className="oc-btn ghost" type="button" onClick={reset}>
            Reset
          </button>
        </div>
      </div>
    </form>
  );
}

